<template>
    <div ref="container">
      <a-modal
        :title="title"
        width="100vw"
        :visible="visible"
        @ok="handleOk"
        @cancel="handleCancel"
        cancelText="取消"
        okText="打印"
      >
      <a-form-model ref="printForm" :model="printForm" :rules="rules" class="form-container">
        <a-form-model-item 
          v-for="item in printItems" 
          :key="item.keyCode" 
          :label="item.keyName" 
          :prop="item.keyCode" 
          class="form-item"
          v-if="item.keyType !== '5'"
        >
          <a-row :gutter="8">
            <a-col :span="24" :md="24">
              <template v-if="item.keyType === '0'">
                  <a-input v-model="printForm[item.keyCode]" disabled/>
              </template>
              <template v-else-if="item.keyType === '1'">
                  <!--  || item.keyType !== '5' -->
                  <a-input v-model="printForm[item.keyCode]" />
              </template>
              <!-- <template v-else-if="item.keyType === '5'">
                  <a-input v-model="printForm[item.keyCode]" />
              </template> -->
              <template v-else-if="item.keyType === '2'">
                  <a-date-picker
                      v-model="printForm[item.keyCode]"
                      show-time
                      format="YYYY-MM-DD HH:mm:ss"
                      value-format="YYYY-MM-DD HH:mm:ss"
                  />
              </template>
              <!-- <template v-else-if="item.keyType === '6'">
                  <a-date-picker
                      v-model="printForm[item.keyCode]"
                      show-time
                      format="YYYY-MM-DD HH:mm:ss"
                      value-format="YYYY-MM-DD HH:mm:ss"
                  />
              </template> -->
            </a-col>  
          </a-row>
          <a-row v-if="item.keyType === '3' || item.keyType === '4'">
            <a-col :span="24">
              <a-select v-model="printForm[item.keyCode]" @change="handlePrintChange($event, item.keyCode)">
                <a-select-option
                  v-for="option in printOptions[item.keyCode]"
                  :key="option.dictValue"
                  :value="option.dictValue"
                    
                >
                  {{ option.dictLable }}
                </a-select-option>
              </a-select>
            </a-col>
          </a-row>                    
        </a-form-model-item>
          <!-- 添加固定的单选按钮 -->
          <a-form-model-item label="打印个数" prop="fixedRadio">
            <a-radio-group v-model="printForm.fixedRadio" @change="handleRadioChange">
                <a-radio value="1">1</a-radio>
                <a-radio value="5">5</a-radio>
                <a-radio value="10">10</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <!-- <a-form-model-item class="ensureBox">
              <a-button type="primary" @click="handlePrint">打印</a-button>
          </a-form-model-item> -->
        </a-form-model>
      </a-modal>
    </div>
  </template>
  
  <script>
    import { getRuleMesByMaterialId, generateCodeForPrint, getAllModules, getCodeFormDict } from '@/api/api'
    import {startPrint } from '@/views/UDIadmin/modules/allPrint'
    import TaskRunner from 'concurrent-tasks'
    export default {
      name: 'printTask',
      data() {
        return {
          title:"操作",
          visible: false,
          model: {},
          labelCol: {
            xs: { span: 24 },
            sm: { span: 5 },
          },
          wrapperCol: {
            xs: { span: 24 },
            sm: { span: 16 },
          },
          objectId: '',
          printItems: [],
          recordList: {},
          printForm: { 
              fixedRadio: '1' // 初始化固定单选按钮的值
          },
          rules: { },
          number: '1',
          printOptions: {},// 修改为嵌套对象
        }
      },
      methods: {
        show(e){
            this.visible = true
            this.recordList = e
            console.log(this.recordList,'this.recordList===============')
            this.handleTracePrint()
        },
        // 去打印获取表单信息
        async handleTracePrint(){
          const params = {
              materialId: this.recordList.materialId,
          } 
          const res = await getRuleMesByMaterialId(params)
          if( res.code == 200 && res.success == true ){
              this.objectId = res.result.uuid
              this.printItems = res.result.params;
                  // 初始化 stepFormItems
                  // this.initStepPrintItems();
                  // 初始化 form 和 rules
              this.printItems.forEach(item => {
                  if (item.keyType !== '6' || item.keyType !== '5') {
                      this.$set(this.printForm, item.keyCode, item.keyValue || '');

                      // 根据 keyType 设置验证规则
                      switch (item.keyType) {
                          case '0': // 常量
                          case '1': // 变量
                          case '5': // 序列号
                              this.rules[item.keyCode] = [{ required: true, message: `${item.keyName}不能为空`, trigger: 'blur' }];
                              break;
                          case '2': // 日期
                              this.rules[item.keyCode] = [{ required: true, message: `${item.keyName}不能为空`, trigger: 'change' }];
                              break;
                          case '3': // 标准字典
                          case '4': // 自定义字典
                              this.rules[item.keyCode] = [{ required: true, message: `${item.keyName}不能为空`, trigger: 'change' }];
                              this.getOptions(item.keyDescription.dicCode, item.keyCode); // 调用 getOptions 并传递 keyCode
                              break;
                          case '6': // 当前日期
                              this.rules[item.keyCode] = [];
                              break;
                          default:
                              break;
                      }
                      // if ( item.keyType === '5' ){
                      //     item.keyName = '打印个数'
                      // }
                  }
              });
          

          } else {
              this.$message.error(res.message)
          }
        },
        async getOptions(dicCode, keyCode) {
          // 根据 keyType 返回相应的选项
          const res = await getCodeFormDict({dictId: dicCode})
          // 把res的值赋给select
          if( res.code === 200 && res.success === true ){
              this.$set(this.printOptions, keyCode, res.result);
          }
        },

        handlePrintChange(value, keyCode) {
          // 找到对应的 option 对象
          const selectedOption = this.printOptions[keyCode].find(option => option.dictValue === value);
          if (selectedOption) {
              // 遍历 formItems，将选中的值赋给对应的 keyCode 对应的 key
              this.printItems.forEach(item => {
                  if (item.keyCode === keyCode) {
                      item.keyDescription.itemValue = selectedOption.dictLable;
                      item.keyDescription.itemCode = selectedOption.uuid
                      item.keyValue = value
                  }
              });
          }
        },
        handleRadioChange(event){
          console.log('Selected radio value:', event.target.value);
          this.number = event.target.value
        },
        handleOk(){
          this.$refs.printForm.validate(valid => {
            if (valid) {
              // 遍历 printItems 并更新每个表单项的 value
              // this.printItems = this.printItems.map(item => {
              //     let value = this.printForm[item.keyCode] || '';
                  
              //     if (moment.isMoment(value)) {
              //         // 使用 moment.js 格式化日期
              //         value = value.format('YYYY-MM-DD HH:mm:ss');
              //         } else if (value instanceof Date) {
              //         // 如果 value 是 Date 对象，使用 moment.js 格式化日期
              //         value = moment(value).format('YYYY-MM-DD HH:mm:ss');
              //         } else if (typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}$/)) {
              //         // 如果 value 是类似 '2025-01-15' 的字符串，添加时间部分
              //         value = moment(value, 'YYYY-MM-DD').format('YYYY-MM-DD HH:mm:ss');
              //         }
              //     return {
              //         ...item,
              //         keyValue: value
              //     };
              // });
              // 这里可以处理打印逻辑
              this.getGenerateCodeForPrint()
              this.visible = false;
              this.printForm = {};
            } else {
                console.log('表单验证失败');
                return false;
            }
          });
        },
        // 获取所有产品列表
        async getGenerateCodeForPrint(){
            const params = {
                ruleId: this.objectId,
                number: this.number,
                params: JSON.stringify(this.printItems),
                planId: this.recordList.id
            }
            const res = await generateCodeForPrint(params)
            if( res.code == 200 && res.success == true ){
                this.printList = res.result
                this.getAllModules() 
                console.log(res.result,'获取的============产品列表===============')
            } else {
                this.$message.error(res.message)
            }
        },
        // 获取所有模版信息
        async getAllModules(){
            const res = await getAllModules()
            console.log(res,'获取的============模版列表===============')
            // 根据uuid  106c9a658773405f88795675ad9bc897值去查res.data里返回的列表，获取出uuid=106c9a658773405f88795675ad9bc897的所有数据
            if( res.code == 200 && res.success == true ){
                this.getModuleInfo = res.result.filter(item => item.uuid === '106c9a658773405f88795675ad9bc897')
                console.log(this.getModuleInfo,'获取的============模版列表===============')
                // startPrint(this.printList, this.getModuleInfo, this.number,doneApi,runner,{pageNumber:i,limit})

                // 确保在获取到模版信息后调用 startPrint 方法
                if ( this.printList && this.getModuleInfo ) {
                    const runner = new TaskRunner();
                    runner.setConcurrency(1);
                    const tasks = [];
                    const limit = 500;
                    const pageNumber = Math.ceil(this.printList.length / limit);

                    for (let i = 1; i <= pageNumber; i++) {
                        tasks.push(async (doneApi) => {
                        try {
                            const beginNumber = (i - 1) * limit;
                            const endNumber = i * limit;
                            const pagePrintList = this.printList.slice(beginNumber, endNumber);
                            // 获取的打印列表this.printList
                            // 获取的打印模版信息this.getModuleInfo
                            // 打印数量this.n umber
                            const copies = 1
                            startPrint(this.printList, this.getModuleInfo[0], copies, doneApi, runner, { pageNumber: i, limit });
                        } catch (error) {
                            this.$message.error('打印失败: ' + error.message);
                            console.log(error.message,'error.message================')
                            doneApi(); // 确保任务完成
                        }
                        });
                    }

                    runner.addMultiple(tasks);
                }

            } else {
                this.$message.error('获取模版列表失败')
            }
        },
        handleCancel(){
          this.visible = false
        },
        // handleOk(){
        //   this.visible = false
        // },
        close(){
          this.visible = false
        }
      }
    }
  </script>